<template lang='pug' src='./Nav.pug'></template>

<script>
import Icon from 'components/icon/icon'
import Image from 'components/image/image-container/image-container'

export default {
  props: ['props'],
  data () {
    return {
      isClicked: false,
      isOpen: false
    }
  },
  computed: {
    links () {
      return this.$router.options.routes
    }
  },
  methods: {
    toggle () {
      this.isClicked = !this.isClicked
      this.isClicked ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    },
    toggle2 () {
      this.isClicked = !this.isClicked
      this.isClicked ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    },
    toggle3 () {
      this.isClicked = !this.isClicked
      this.isClicked ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    },
    openModal () {
      this.$store.dispatch('VIEW_SHOWMODAL', true)
    }
  },
  components: {
    Icon,
    Image
  }
}
</script>



// WEBPACK FOOTER //
// Nav.vue?252b10e7